import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../config/api.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TelefonoPayload } from '../models/telefono.model';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TelefonoService {
  private apiUrl = API_ENDPOINTS.telefono;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  crear(sucursalId: number, telefonoPayload: TelefonoPayload) {
    return this.http
      .post(
        this.apiUrl + '/agregar/' + sucursalId,
        telefonoPayload,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }
  editar(
    sucursalId: number,
    telefonoId: number,
    telefonoPayload: Partial<TelefonoPayload>,
  ) {
    return this.http
      .put(
        this.apiUrl + '/editar/' + sucursalId + '/' + telefonoId,
        telefonoPayload,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }
  eliminar(sucursalId: number, telefonoId: number) {
    return this.http
      .delete(
        this.apiUrl + '/eliminar/' + sucursalId + '/' + telefonoId,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    const message =
      error?.error?.message || error?.message || 'Error en la solicitud';
    return throwError(() => new Error(message));
  }
}
